import { render } from "./Configuracao.vue?vue&type=template&id=1cdb89c1&ts=true"
import script from "./Configuracao.vue?vue&type=script&lang=ts"
export * from "./Configuracao.vue?vue&type=script&lang=ts"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__